module.exports = __webpack_public_path__ + "img/86.7f2850e1.png";